import React from 'react';
import { ErrorBoundary as EBSentry } from '@bloomays-lib/common.monitoring/browser';
import { FallbackError } from './FallbackError';

const GlobalErrorBoundary = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
  return (
    <EBSentry
      fallback={({ error }: { error: unknown; componentStack: string; eventId: string; resetError: () => void }) =>
        React.createElement(FallbackError, { errorText: (error as Error)?.message })
      }
    >
      {children}
    </EBSentry>
  ) as React.JSX.Element;
};

export { GlobalErrorBoundary };
export default GlobalErrorBoundary;
